import { InnerDimension } from './inner-dimension.model';
export class Column {
  id: string
  name: string
  innerDimension: InnerDimension[] = [];
}
